var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddfeatureicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3478 0H1.73913C1.27804 0.00051785 0.835989 0.183914 0.509951 0.509952C0.183913 0.83599 0.00051785 1.27804 0 1.73913V18.2609C0.00051785 18.722 0.183913 19.164 0.509951 19.49C0.835989 19.8161 1.27804 19.9995 1.73913 20H24.3478C24.8089 19.9995 25.251 19.8161 25.577 19.49C25.903 19.164 26.0864 18.722 26.087 18.2609V1.73913C26.0864 1.27804 25.903 0.83599 25.577 0.509952C25.251 0.183914 24.8089 0.00051785 24.3478 0ZM24.3478 18.2609H1.73913V1.73913H24.3478L24.3489 18.2609H24.3478Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7393 6.087H21.7393V7.82613H11.7393V6.087ZM8.69582 10H21.7393V11.7392H8.69582V10ZM8.69582 13.9131H21.7393V15.6522H8.69582V13.9131ZM3.96338 3.91309V10.9198L9.35316 7.14694L3.96338 3.91309Z",
    fill: "#ECECEC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddfeatureicon);
export default __webpack_public_path__ + "static/media/addfeatureicon.36892916d8effdcc543e9dad133a06d7.svg";
export { ForwardRef as ReactComponent };